/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDrone} from '@fortawesome/pro-duotone-svg-icons';

const CombineToolIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faDrone} {...props} />
);

export default CombineToolIcon;
